export default __webpack_public_path__ + "static/media/loanbuilder_paypal--vertical-color-knockout.b6bdeb0d.svg";